import React from 'react';
import { Trans, useTranslation } from 'react-i18next';
import { FormResponseErrorType, FormUtils, useFormContext } from '../../../components/molecules/Form';
import LiveRegion from '../../../components/atoms/LiveRegion/LiveRegion';
import FormFile from '../../../components/molecules/Form/components/FormFile/FormFile';
import { ButtonActionConfirm } from '../../../components/molecules/Btn/ButtonWrapper';
import FormsRow, { FormsRowModifier } from '../../../components/molecules/Form/components/FormsRow/FormsRow';
import { getAcceptString } from '../../FileUpload/utils/getAcceptString';

type ConfigurationUploadTemplateProperties = {
  fileExtensions: string[];
  name: string;
  namespace: string;
};

export default function ConfigurationUploadTemplate({
  namespace,
  name,
  fileExtensions,
}: ConfigurationUploadTemplateProperties) {
  const { inputs, status, onChange, getStatus, submitActionEnabled } = useFormContext();
  const { t, i18n } = useTranslation(namespace);
  const messages = {
    [FormResponseErrorType.DUPLICATED_ID]: FormUtils.createStatusMessage(
      t(`${namespace}:edit.status.${FormResponseErrorType.DUPLICATED_ID}`)
    ),
    [FormResponseErrorType.INVALID_FILE]: FormUtils.createStatusMessage(
      t(`${namespace}:edit.status.${FormResponseErrorType.INVALID_FILE}`)
    ),
    [FormResponseErrorType.INVALID_CSV_FILE]: FormUtils.createStatusMessage(
      t(`${namespace}:edit.status.${FormResponseErrorType.INVALID_CSV_FILE}`)
    ),
  };

  return (
    <>
      <FormsRow>
        <FormFile accept={getAcceptString(inputs[name].constraints)} id={name} name={name} onChange={onChange}>
          {fileExtensions && (
            <Trans
              i18nKey={`${namespace}:label`}
              i18n={i18n}
              values={fileExtensions.reduce((acc: Record<string, string>, fileExtension: string, index: number) => {
                acc[`ex${index}`] = fileExtension.toUpperCase();
                return acc;
              }, {})}
              components={fileExtensions.map(fileExtension => (
                <abbr key={fileExtension} title={t(`${namespace}:${fileExtension}`) || fileExtension}>
                  dummy
                </abbr>
              ))}
            />
          )}
        </FormFile>
      </FormsRow>
      <FormsRow modifier={FormsRowModifier.RIGHT}>
        <ButtonActionConfirm text={t('button')} type="submit" disabled={!submitActionEnabled} />
      </FormsRow>
      <LiveRegion htmlTag="div" invisible={false} ariaAtomic>
        {getStatus(messages, status)}
      </LiveRegion>
    </>
  );
}
